import { Component, OnInit, TemplateRef } from '@angular/core';
import { AuthenticationService, UserService } from '../_services/index';
import { CognitoService } from '../_services/Cognito.service';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { GetuserService } from '../_services/getuser.service';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {
  model: any = {};
  logoimage: any;
  minLoader: any;
  loading: boolean;
  response: any = [];
  status: boolean;
  isResetData: boolean = false;
  matchPassword: boolean = false;
  userName: string;
  form: FormGroup;
  showOtp: boolean = false;
  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout : 1000
  }
  modalRef: BsModalRef;


  constructor(private authenticationService: AuthenticationService,
    private cognitoService: CognitoService,
    private router: Router,
    private fb: FormBuilder,
    private service: GetuserService,
    private modalService: BsModalService,
  ) {
  }

  ngOnInit() {
    this.minLoader = '../../assets/images/smallLoader.gif';
    this.logoimage = '../../assets/images/logo.png';
    this.formInit();
  }

  private formInit() {
    this.form = this.fb.group({
      confirmationCode: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(16)]],
      confirmNewPassword: ['', Validators.required]
    }, {
      validators: this.matchNewPasswords
    });
  }

  matchNewPasswords(formGroup: FormGroup) {
    const newPassword = formGroup.get('newPassword').value;
    const confirmNewPassword = formGroup.get('confirmNewPassword').value;
    return newPassword === confirmNewPassword ? null : { passwordsMismatch: true };
  }
  
  get f() {
    return this.form.controls;
  }
 /**
   * Function to open modal
   * @param template
   */
 openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(
    template,
    Object.assign({}, { class: "gray modal-md" })
  );
}

  /**
   * function to Disbale Modal
   * @param event
   */
  _hidemodal(event: any) {
    this.modalRef.hide();
  }
  
  onKeyCheckpasswordConfirm(event: any) {
    if (event.target.value !== undefined) {
      if (this.form.controls["newPassword"].value === event.target.value) {
        this.matchPassword = false; 
      } else {
        this.matchPassword = true;
      }
    } else {
      this.matchPassword = false;
    }
  }

  forgotPassword(template: TemplateRef<any>): void {
      let $this = this;
      this.cognitoService.forgotPassword(this.model.email)
        .then((reponse) => {
          console.log(reponse);
          this.userName = this.model.email;
          $this.showOtp = true
        })
        .catch((error) => {
          if(error.code === "InvalidParameterException"){
           this.openModal(template);
          }
        });
    
  }

  confirmForgotPassword( confirmationCode: string, newPassword: string,confirmNewPassword: string): void {
    if (this.form.valid) {
    let $this = this;
    this.cognitoService.confirmForgotPassword(this.userName, confirmationCode, newPassword)
      .then((reponse) => {
        this.loading = true;
        $this.webForgetPassword(this.userName,newPassword,confirmNewPassword,confirmationCode);
        this.router.navigate(['/login']);
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
    }
  }

  webForgetPassword(username: string, newPassword: string,confirmNewPassword: string,confirmationCode: string) {
    this.authenticationService.webForgotPassword(username, newPassword,confirmNewPassword,confirmationCode)
      .subscribe(
        data => {
          if (data.status === 200) {
            this.status = true;
          } else {
            this.status = false;
          }
          this.response = data;

          this.loading = false;
        },
        error => {
          this.loading = false;
        });
  }

  confirmForgetPasswordPIN(pin) {
    pin = pin.replace(/\s/g, '');
    let $this = this;
    this.authenticationService.webForgotPasswordPIN(this.userName, pin)
      .subscribe(
        data => {
          if (data.status === 200) {
            $this.isResetData = true
            $this.showOtp  = false
          } else {
            this.status = false;
          }
          this.response = data;

          this.loading = false;
        },
        error => {
          this.loading = false;
        });
  }

  okButton(event){
    this.cognitoService.resendOtp(this.service.username)
    .then((reponse) => {
     this.router.navigate(['/register']);
     this._hidemodal(event)
    })
    .catch((error) => {
    
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forgot-password/forgot-password.component.ts